// @flow
import cookies from 'js-cookie'
import { type Event, type Effect } from 'effector'
import { createGate } from 'effector-react'
import { every, stop } from 'visibilityjs'

import { Storage } from 'utils/storage'
import { SessionService } from 'services/session'
import { setSpyValues } from 'features/form-spy/model/events'

import { menuApi } from '../api'
import { PAGE_IDS } from '../data/navData'
import type { NavCounts } from '../types'

import { MenuDomain } from './domain'
import { SIDEBAR_TOUCHED, ACTIVE_TAB_STORAGE_KEY } from './constants'

let timer = null

export const closeSidebar: Event<void> = MenuDomain.event('close sidebar')

export const closeSidebarByWindowScroll: Event<void> = MenuDomain.event('close sidebar by window scroll')

export const openSidebar: Event<void> = MenuDomain.event('open sidebar')

export const toggleSidebar: Event<void> = MenuDomain.event('toggle sidebar')

export const changeTab: Event<{ pageId: $Values<typeof PAGE_IDS>, href?: string }> = MenuDomain.event(
  'change sidebar tab'
)

export const logoutPressed: Event<SyntheticEvent<HTMLButtonElement>> = MenuDomain.event('logout button is pressed')

export const FetchCountsGate = createGate<{}>()

export const fetchCounts: Effect<void, NavCounts> = MenuDomain.effect('fetch nav counts', {
  async handler() {
    const counts = await menuApi.fetchCounts()

    return counts
  },
})

FetchCountsGate.open.watch(() => {
  if (timer === null) fetchCounts()
  timer = every(1000 * 60 * 5, fetchCounts)
})

FetchCountsGate.close.watch(() => {
  if (timer !== null) stop(timer)
})

changeTab.watch((params) => {
  if (window.location.hostname.includes('foxford.ru')) {
    cookies.set(ACTIVE_TAB_STORAGE_KEY, params.pageId, { domain: '.foxford.ru', path: '/' })
  } else {
    cookies.set(ACTIVE_TAB_STORAGE_KEY, params.pageId)
  }

  setSpyValues({ type: params.pageId })
})

logoutPressed.watch(() => {
  SessionService.logOut()
})

closeSidebar.watch(() => {
  if (!Storage.getItem(SIDEBAR_TOUCHED)) Storage.setItem(SIDEBAR_TOUCHED, 'true')
})
